import { useParams, useNavigate } from "react-router-dom";
import telefonoProdotti from "../data/telefonoProdotti.json"
import bigiotteriaProdotti from "../data/bigiotteriaProdotti.json"
import casaProdotti from "../data/casaProdotti.json"

export default function PopUpImg(){
    

    const navigate = useNavigate();

    const {imgId} = useParams();
    const arrImgId = imgId.split("-");
    const titolo = arrImgId[arrImgId.length-1].split("_").join(" ")

    let prezzo;
    let imgVeroArr;
    let descrizione;

    if(arrImgId[0]==="telefonoProdotti"){
        prezzo = telefonoProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].prezzo;
        imgVeroArr=(telefonoProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].immagine).slice(1);
        descrizione = telefonoProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].descrizione;
    }else if (arrImgId[0]==="bigiotteriaProdotti"){
        prezzo = bigiotteriaProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].prezzo;
        imgVeroArr=(bigiotteriaProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].immagine).slice(1);
        descrizione = bigiotteriaProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].descrizione;
    }else if(arrImgId[0]==="casaProdotti"){
        prezzo = casaProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].prezzo;
        imgVeroArr=(casaProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].immagine).slice(1);
        descrizione = casaProdotti[arrImgId[1]][arrImgId[2]][arrImgId[3]].descrizione;
    }
    
    const ritornoPrezzo = ()=>{
        if(prezzo>=0){
            return <h3 className="prezzo">€{prezzo}</h3>
        }
        return <h3 className="prezzo">{prezzo}</h3>
    }

    function cliccatoImmago(id){
        const elem = document.getElementById(id)
        if(elem.classList.contains("normale")){
            elem.classList.remove("normale");
            elem.classList.add("grande");
            document.getElementById("titoloPop").classList.add("opaLow");
            document.querySelector(".descrizione").classList.add("opaLow");
            document.querySelector(".prezzo").classList.add("opaLow");
            for(const imm in imgVeroArr){
                if(`immago${imm}`!==id){
                    document.getElementById(`immago${imm}`).classList.add("opaLow");
                }
            }
        }else{
            elem.classList.add("normale");
            elem.classList.remove("grande");
            document.getElementById("titoloPop").classList.remove("opaLow");
            document.querySelector(".descrizione").classList.remove("opaLow");
            document.querySelector(".prezzo").classList.remove("opaLow");
            for(const imm in imgVeroArr){
                if(imm!==id){
                    document.getElementById(`immago${imm}`).classList.remove("opaLow");
                }
            }
        }
    }

    return (
        <div className="popup-img">
            <h1 id="titoloPop">{titolo}</h1>
            <span  onClick={()=>navigate(-1)}>&times;</span>
            <div className="contenitoreImmagoPadre">
            {imgVeroArr.map((elem,index)=>
                
                <div className="contenitoreImmagoFiglio" key={crypto.randomUUID()}>
                    <img onClick={()=>cliccatoImmago(`immago${index}`)} id={`immago${index}`} className="normale" src={elem} alt="immagine" />
                </div>
                
            )}
            </div>
            <h2 className="descrizione">{descrizione}</h2>
            {ritornoPrezzo()}
        </div>
    )
}